import More from './More';
import Tracks from './Tracks';

function SoundCloud() {
  return (
    <div className="h-screen w-screen">
      <div
        className="px-4 grid grid-cols-1 sm:grid-cols-2 md:mr-56 xl:grid-cols-3 items-center"
      >
        {Tracks.map(item => (
          <section className='mb-5 sm:mx-2'>
            <iframe
              className="border-0 rounded-md"
              title="underPage"
              width="100%"
              height="200"
              frameborder="no"
              allow="autoplay"
              src={
                'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/' +
                item.track_id +
                '&color=%23' +
                item.track_color +
                '&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true'
              }
            ></iframe>
          </section>
        ))}
        <More />
      </div>
      <div className="py-44"></div>
    </div>
  );
}

export default SoundCloud;
